// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import App from "./App"
import Datepicker from "vuejs-datepicker"
import eventManager from "./utilities/event-manager"
import http from "@/http"
import kebabCase from "lodash/kebabCase"
import loadingManager from "./utilities/loading-manager"
import modalManager from "./utilities/modal-manager"
import router from "./router"
import Vue from "vue"
import VueTable from "vuetable-2"
import VTooltip from "v-tooltip"
import VuetablePagination from "vuetable-2/src/components/VuetablePagination"
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo"
import IdleVue from "idle-vue"

import dayjs from "dayjs"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
dayjs.extend(isSameOrAfter)

// allow all components to use the same axios instance
window.axios = Vue.prototype.$http = http

Vue.config.productionTip = false

Vue.use(IdleVue, {
    eventEmitter: new Vue(),
    idleTime: 5000
})

Vue.prototype.$eventManager = eventManager
Vue.prototype.$loadingManager = loadingManager
Vue.prototype.$modalManager = modalManager

Vue.use(VTooltip)

Vue.use(VueTable)
Vue.component("vue-table", VueTable)

Vue.use(VuetablePagination)
Vue.component("vue-table-pagination", VuetablePagination)

Vue.use(VuetablePaginationInfo)
Vue.component("vue-table-pagination-info", VuetablePaginationInfo)

Vue.use(Datepicker)
Vue.component("datepicker", Datepicker)

// find all component files to import
const requireComponent = require.context(
    "./components",
    true,
    /\w+\.(vue|js)$/
)

/**
 * Automatically import all components from the source directory.
 */
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)

    const componentName = kebabCase(
        fileName.split("/").pop().replace(/\.vue$/, "")
    )

    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App />"
})



// WEBPACK FOOTER //
// ./src/main.js